// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span:first-child\n  + h1\n  + div\n  > div:first-child#content\n  > h1:first-child.page-title {\n  display: none;\n}\n.tab-list {\n  margin-bottom: 0 !important;\n}\n.list-item {\n  /* limiting width of list item to 85% so that longer text is fully visible\n  within the viewport specially on mobile screen */\n  max-width: 85%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
